import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';
import { EntityName } from 'src/types/EntityName';

const MEAL_CREDIT_ENTITY_NAME: EntityName = {
  singular: 'meal credit',
  plural: 'meal credits',
};

const LINE_OF_CREDIT_ENTITY_NAME: EntityName = {
  singular: 'line of credit',
  plural: 'lines of credit',
};

export const useMealCreditEntityName = (): {
  MEAL_CREDIT_ENTITY_NAME: EntityName;
} => {
  const { value: isBalanceUiEnabled } = useFeatureFlag(
    FeatureFlag.ENABLE_BALANCE_UI
  );

  return {
    MEAL_CREDIT_ENTITY_NAME: isBalanceUiEnabled
      ? MEAL_CREDIT_ENTITY_NAME
      : LINE_OF_CREDIT_ENTITY_NAME,
  };
};
